import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueScrollmagic from 'vue-scrollmagic'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
// import inViewPort from './directives/inViewPort'
import inViewportDirective from 'vue-in-viewport-directive'

Vue.use(VueScrollmagic)
Vue.config.productionTip = false
Vue.use(BootstrapVue)
// Vue.directive('inViewPort', inViewPort)
Vue.directive('in-viewport', inViewportDirective)

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
